module.exports = __webpack_public_path__ + "static/media/lexus-headset.bdbd1ee9.svg";